import PropTypes from "prop-types";
import { useQuery } from "@tanstack/react-query";

import ConfirmDeleteDialog from "components/modals/ConfirmDeleteDialog";
import CallDispositionService from "services/CallDispositions";

const DeleteDispositionModal = ({
  open,
  onOpenChange,
  dispositionId,
  dispositionName,
  onConfirm,
}) => {
  const { data: dialSessions = [] } = useQuery({
    queryKey: ["disposition-dial-sessions", dispositionId],
    queryFn: () =>
      CallDispositionService.getDispositionWithDialSession(dispositionId),
    enabled: !!dispositionId && open,
  });

  // AlertDialogDescription renders a <p>, which can't legally contain <p> or
  // <ul>, so the block structure is built from spans instead.
  const description = (
    <>
      {dialSessions.length > 0 && (
        <>
          <span className="tw:block">
            The &quot;{dispositionName}&quot; Disposition is being used in the
            following dial sessions:
          </span>
          <span className="tw:mt-1 tw:mb-2 tw:block tw:pl-4">
            {dialSessions.map(({ id, name }) => (
              <span key={id} className="tw:block">
                ID {id} - {name}
              </span>
            ))}
          </span>
        </>
      )}
      <span className="tw:block">
        Are you sure you want to delete the &quot;{dispositionName ?? ""}&quot;
        Call Disposition?
      </span>
    </>
  );

  return (
    <ConfirmDeleteDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Delete disposition?"
      description={description}
      onConfirm={onConfirm}
    />
  );
};

DeleteDispositionModal.propTypes = {
  open: PropTypes.bool,
  onOpenChange: PropTypes.func,
  dispositionId: PropTypes.number,
  dispositionName: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
};

export default DeleteDispositionModal;
